import { AnyAction } from 'redux';
import {
  GlobalActions,
  GlobalCommonInsuranceDataReceivedAction,
  GlobalVorbelegungForBeibehaltungRequestedAction,
} from '@ps20-frontend/shop-integration-redux';
import {
  determineAssekuranztarifFromTarifbereich,
  UnfallVorbelegungdaten,
} from '@ps20-frontend/frontend-models';
import { convertDateFormatFromShortIsoToLocalState } from '@ps20-frontend/utils';
import { Tarifbereich } from '@ps20/bff-models';
import { IAppState } from '../appState';

export const versicherungsnehmerReducer = function (
  sectionState: IAppState['versicherungsnehmer'] = null,
  action: AnyAction,
): IAppState['versicherungsnehmer'] {
  switch (action.type) {
    case GlobalActions.COMMON_INSURANCE_DATA_RECEIVED:
      return setVn(sectionState, action as GlobalCommonInsuranceDataReceivedAction);
    case GlobalActions.UPDATE_ASSEKURANZTARIF_DATA_AFTER_VV_LOAD:
      return { ...sectionState, isAssekuranztarif: action.payload };
    case GlobalActions.UPDATE_ASSEKURANZTARIF_DATA:
      return { ...sectionState, isAssekuranztarif: action.payload };
    case GlobalActions.VORBELEGUNG_FOR_BEIBEHALTUNG_REQUESTED:
      return loadVnFromVorvertrag(
        sectionState,
        action as GlobalVorbelegungForBeibehaltungRequestedAction,
      );
    case GlobalActions.TARIFBEREICH_CHANGED:
      return {
        ...sectionState,
        tarifbereich: action.payload,
        isAssekuranztarif: determineAssekuranztarifFromTarifbereich(action.payload),
      };
    default:
      return sectionState;
  }
};

function setVn(
  sectionState: IAppState['versicherungsnehmer'],
  action: GlobalCommonInsuranceDataReceivedAction,
): IAppState['versicherungsnehmer'] {
  const { adresse, geburtsdatum, isAssekuranztarif, juristisch, kundennummer } =
    action.payload.versicherungsnehmer;
  return {
    ...sectionState,
    adresse,
    geburtsdatum,
    isAssekuranztarif,
    juristisch,
    kundennummer,
    kundenverwaltungID: action.payload.vnKundenverwaltungID,
  };
}

function loadVnFromVorvertrag(
  sectionState: IAppState['versicherungsnehmer'],
  action: GlobalVorbelegungForBeibehaltungRequestedAction,
): IAppState['versicherungsnehmer'] {
  const vorbelegungsdaten = action.payload as UnfallVorbelegungdaten;
  return {
    adresse: vorbelegungsdaten.vnAdresse,
    geburtsdatum: convertDateFormatFromShortIsoToLocalState(vorbelegungsdaten.geburtsdatumVn),
    kundenverwaltungID: vorbelegungsdaten.kundennummer,
    juristisch: false,
    isAssekuranztarif: [Tarifbereich.A, Tarifbereich.FI].includes(vorbelegungsdaten.tarifbereich),
  };
}
